<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "MobileMappingSignupForm",
  data: () => ({
    formValid: false,
    firstNameRules: [
      v => !!v || "Bitte geben Sie Ihren Vornamen an",
    ],
    lastNameRules: [
      v => !!v || "Bitte geben Sie Ihren Nachnamen an",
    ],
    emailRules: [
      v => !!v || "Bitte geben Sie Ihre E-Mail Adresse an",
      v => /.+@.+\..+/.test(v) || "E-Mail Adresse ist nicht gültig",
    ],
    messageRules: [
      v => !!v || "Bitte geben Sie Ihre Nachricht an",
    ],
    contactForm: {
      submitted: false,
      firstname: "",
      name: "",
      phone: "",
      mail: "",
      message: "",

    },
  }),
  computed: {
    ...mapGetters('user', ["userEmail", "firstName", "lastName"]),
  },
  mounted() {
    this.contactForm.mail = this.userEmail;
    this.contactForm.name = this.lastName;
    this.contactForm.firstname = this.firstName;
  },
  methods: {
    ...mapActions('mobileMapping', ['sendSignupMessage']),
    async onSubmit() {
      await this.sendSignupMessage(this.contactForm);
      this.contactForm.submitted = true;
    },
  }
}
</script>

<template>
<div>
  <div class="h2 mb-5 new-font-medium">Anfrage für Ihre Kommune</div>
  <p>Sie möchten Mobile Mapping für Ihre Kommune nutzen oder haben Fragen zu unserem Angebot? Schreiben Sie uns und wir melden uns bei Ihnen.</p>
  <v-row no-gutters>
    <v-col cols="12" sm="6">
  <v-sheet elevation="0" color="white" style="padding: 16px; border-radius: 5px">
    <v-form @submit.prevent="onSubmit" v-model="formValid" v-if="!contactForm.submitted">
      <v-row no-gutters class="contact-row">
        <v-col cols="12" sm="6" class="contact-col">
          <v-text-field
              label="Vorname"
              :rules="firstNameRules"
              v-model="contactForm.firstname"
              filled
              dense
              background-color="#F1CBDB"
              required />
        </v-col>
        <v-col cols="12" sm="6" class="contact-col">
          <v-text-field
              label="Nachname"
              :rules="lastNameRules"
              v-model="contactForm.name"
              filled
              dense
              required />
        </v-col>
        <v-col cols="12" sm="6" class="contact-col">
          <v-text-field
              label="Telefonnummer (Optional)"
              v-model="contactForm.phone"
              filled
              dense
              background-color="#B4005520" />
        </v-col>
        <v-col cols="12" sm="6" class="contact-col">
          <v-text-field
              label="E-Mail Adresse"
              v-model="contactForm.mail"
              :rules="emailRules"
              filled
              dense
              background-color="#B4005520"
              required />
        </v-col>
        <v-col cols="12" class="contact-col">
          <v-textarea
              label="Ihre Nachricht"
              v-model="contactForm.message"
              :rules="messageRules"
              filled
              dense
              background-color="#B4005520"
              placeholder="Was möchten Sie uns mitteilen?"
              required />
        </v-col>
      </v-row>
      <v-btn color="primary" class="mx-auto px-10" type="submit" :disabled="!formValid">
        Abschicken
      </v-btn>
    </v-form>
    <div v-else class="text-center">
      <div class="text-center font-weight-bold text-h4 my-5">Vielen Dank!</div>
      <p>Ihre Anfrage ist bei uns eingegangen. Wir melden uns schnellstmöglich bei Ihnen zurück</p>
    </div>
  </v-sheet>
    </v-col>
  </v-row>
</div>
</template>

<style scoped>

.contact-col {
  padding: 4px 8px !important;
}

.circle-icon {
  height: 75px !important;
  width: 75px !important;
  border-radius: 50%;
  background: transparent linear-gradient(222deg, #931880 0%, #B40055 100%) 0% 0% no-repeat padding-box;
}
</style>